<template>
	<v-app :class="uamsShow ? 'uamsShow' : ''" :style="uamsShow ? 'margin: 12px;' : ''">
		<v-container class="height-100" style="max-width: 1200px">
			<v-form ref="entData" v-model="valid" :model="entData">
				<v-card elevation="0">
					<v-card-title class="pt-0 headline font-weight-bold">
						<v-icon class="mr-2" size="30" color="blue">mdi-police-badge-outline</v-icon>企业资质审核
						<v-spacer />
						<v-btn @click="$router.back(-1)" icon><v-icon>mdi-undo-variant</v-icon></v-btn>
					</v-card-title>
					<v-card-text class="black--text">
						<div class="pb-2 mb-3 title" style="position: relative"><span class="title_icon"></span>单位信息</div>
						<v-list-item class="ml-n2 mb-3">
							<v-list-item-avatar color="blue" size="46">
								<v-icon size="36" dark>mdi-microsoft-edge</v-icon>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title class="font-weight-bold">{{ entData.uniName }}</v-list-item-title>
								<v-list-item-subtitle> 统一信用证：{{ entData.uniCode }} </v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
						<v-row>
							<v-col cols="12" md="12"> <span class="grey--text table_span">联系人：</span>{{ entData.contact }}</v-col>
							<v-col cols="12" md="12"> <span class="grey--text">联系电话：</span>{{ entData.mobile }} </v-col>
							<v-col cols="12" md="12"> <span class="grey--text">单位地址：</span>{{ entData.address }} </v-col>
							<v-col cols="12" md="12">
								<span class="grey--text">单位介绍：</span>
								{{ entData.descrition }}
							</v-col>
						</v-row>
						<v-divider class="my-4" style="opacity: 0.5" />
						<div class="pb-2 mb-3 title" style="position: relative"><span class="title_icon"></span>服务资质</div>
						<v-row>
							<v-col cols="12" md="12" class="pb-0">
								<v-list-item class="ml-n2">
									<v-list-item-avatar rounded size="46">
										<v-img :src="entData.projIcon"></v-img>
									</v-list-item-avatar>
									<v-list-item-content>
										<v-list-item-title class="font-weight-bold">{{ entData.projName }}</v-list-item-title>
										<v-list-item-subtitle> 编号：{{ entData.projCode }}</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-col>
							<v-col cols="12" md="12"> <span class="grey--text">资质说明：</span>{{ entData.projNote }} </v-col>
						</v-row>
						<v-divider class="my-4" style="opacity: 0.5" />
						<v-row :class="entData.state | dict('0:examine_bg0/1:examine_bg1/2:examine_bg2')">
							<div class="pb-2 ml-4 mt-3 title" style="position: relative"><span class="title_icon"></span>申请信息</div>
							<v-col cols="12" md="12" class="pb-0">
								<v-list-item class="ml-n2">
									<v-list-item-avatar color="primary" size="56">
										<v-icon size="34" dark>mdi-police-badge-outline</v-icon>
									</v-list-item-avatar>
									<v-list-item-content>
										<v-list-item-title class="font-weight-bold">{{ entData.projName }}</v-list-item-title>
										<v-list-item-subtitle> 操作时间：{{ entData.operateTime | date("yyyy年MM月dd日 HH:mm:ss") }} </v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-col>
							<v-col cols="12" md="12"> <span class="grey--text">联系人员：</span>{{ entData.linkName }} </v-col>
							<v-col cols="12" md="12"> <span class="grey--text">联系电话：</span>{{ entData.linkTele }} </v-col>
							<v-col cols="12" md="12">
								<span class="grey--text">服务地区：</span>
								<!-- <wtk-select
									placeholder="请选择服务地区"
									v-model="entData.areaCode"
									list="330102:上城区/330105:拱墅区/330106:西湖区/330108:滨江区/330109:萧山区/330110:余杭区/330111:富阳区/330112:临安区/330113:临平区/330114:钱塘区/330122:桐庐县/330127:淳安县/330182:建德市"
									dense
									outlined
									hide-details
									:multi="true"
									class="d-inline-block"></wtk-select> -->
								{{ entData.areaName }}
							</v-col>
							<v-col cols="12" md="12">
								<span class="grey--text">有效期限：</span>
								<span>{{ entData.btime | date("yyyy-MM-dd") }} ~ {{ entData.etime | date("yyyy-MM-dd") }}</span>
								<v-menu v-if="entData.state == 0" ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="dates" transition="scale-transition" nudge-top="24" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<a v-bind="attrs" v-on="on" class="ml-2">修改</a>
									</template>
									<v-date-picker v-model="dates" :min="new Date() | date('yyyy-MM-dd')" range no-title scrollable>
										<v-spacer></v-spacer>
										<v-btn text color="primary" @click="menu = false">返回</v-btn>
										<v-btn text color="primary" @click="timeSave">确定</v-btn>
									</v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="12"> <span class="grey--text">申请说明：</span>{{ entData.note }} </v-col>
							<v-col cols="12" md="12">
								<span class="grey--text v-align-top">附件信息：</span>
								<a :href="entData.file" target="_blank">查看附件</a>
							</v-col>
							<v-col cols="12" md="12" v-if="entData.state == 0" class="pt-1">
								<span class="grey--text">申请审批：</span>
								<v-radio-group v-model="state" row mandatory hide-details class="d-inline-block mt-0" style="vertical-align: sub">
									<v-radio label="同意" value="1"></v-radio>
									<v-radio label="拒绝" value="2"></v-radio>
								</v-radio-group>
							</v-col>

							<v-col cols="12" md="12">
								<span class="grey--text">审核意见：</span>
								<span v-if="entData.state != '0'">{{ entData.stateNote }}</span>
								<v-textarea v-else v-model="entData.stateNote" :rules="[(v) => !!v || '审核意见不能为空!']" placeholder="请输入审核意见" class="mt-3" rows="3" outlined></v-textarea>
							</v-col>
							<v-col cols="12" md="12" v-show="entData.state != 0">
								<span class="grey--text">审核人员：</span>
								<span v-if="entData.state != '0' && entData.operator">{{ entData.operator }}</span>
							</v-col>
							<v-col cols="12" md="12" v-show="entData.state != 0">
								<span class="grey--text">审核时间：</span>
								<span v-if="entData.state != '0' && entData.operateTime">{{ entData.operateTime | date("yyyy-MM-dd HH:mm:ss") }}</span>
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions class="pt-0 pb-6 pl-4" :class="entData.state == 0 && 'mt-n5'">
						<v-btn v-if="entData.state == 0" @click="save" class="success mr-2" elevation="0"><v-icon>mdi-check</v-icon> 提交 </v-btn>
						<v-btn @click="$router.back(-1)" class="primary mr-2" elevation="0"><v-icon>mdi-undo-variant</v-icon> 返回 </v-btn>
						<v-btn @click="record" class="white--text orange" elevation="0"><v-icon>mdi-clock-time-eight-outline</v-icon> 记录 </v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
			<!-- 申请进度 -->
			<dept-ureg-view ref="mView" />
		</v-container>
		<wtk-message><!--弹出消息区域--></wtk-message>
	</v-app>
</template>
<script>
import Request from "@/commons/request";
import Storage from "@/commons/storage";
import Message from "@/components/message";
import DeptUregView from "../dash/dept-ureg-view";
// import wtkSelect from "@/components/dictionary/WtkSelect";
export default {
	components: { DeptUregView },
	data: () => ({
		bid: "",
		entData: {},
		dates: [],
		menu: false,
		valid: false,
		state: null,
		user: {},
		areaShow: false,
		uamsShow: false,
	}),
	watch: {
		$route(to, from) {
			if (to.query.drid != from.query.drid) {
				if (to.query.drid != undefined) {
					this.view(to.query.drid);
					this.bid = to.query.bid;
				}
			}
		},
	},
	mounted() {
		this.user = Storage.get("_wit_acis_users");
		this.$vuetify.theme.dark = false;
		this.bid = this.$route.query.bid;
		this.view(this.$route.query.drid);
	},
	methods: {
		//申请详情
		view(id) {
			this.uamsShow = location.href.includes("/uams-");
			if (this.user.areacode?.length == 4 || this.user.areaCode?.length == 4) {
				this.areaShow = true;
			} else {
				this.areaShow = false;
			}
			Request.getForm("/udsx/dept-ureg/view", { id: id }).then((res) => {
				this.entData = res.data;
				this.entData.state == "0" && (this.entData.stateNote = "");
				// res.data.areaCode.length <= 4 && this.getTree(res.data.areaCode);
				this.entData.format = this.entData.file.substring(this.entData.file.lastIndexOf(".") + 1, this.entData.file.length);
				this.entData.time = `${res.data.btime.slice(0, 10)}~${res.data.etime.slice(0, 10)}`;
				this.dates = [res.data.btime, res.data.etime];
			});
		},
		// 加载下级地区
		getTree(code) {
			this.$vtk.request.getForm(`dict/area/next/${code}`).then((res) => {
				console.log(res);
				// this.areaItems = res.data;
				// this.$forceUpdate(); //强制刷新
			});
		},
		//进度记录
		record() {
			this.$refs.mView.view(this.entData);
		},
		tolist() {
			this.$router.push({ path: "/dept-roles-page", query: { bid: this.bid } });
		},
		// 审核资质选择日期
		timeSave() {
			if (this.dates.length > 1) {
				this.dates = this.dates.sort();
				this.entData.time = this.dates.join(" ~ ");
				this.entData.btime = this.dates[0];
				this.entData.etime = this.dates[1];
				this.$refs.menu.save(this.dates);
			} else {
				this.entData.time = "";
				Message.toast("请选择时间区间", { color: "error" });
				this.$refs.menu.save(this.dates);
			}
		},
		//提交审核
		save() {
			let arr = [];
			let json = JSON.parse(this.entData.stateJson);
			if (Array.isArray(json)) {
				arr = JSON.parse(this.entData.stateJson);
			} else {
				arr = json.length > 6 ? [JSON.parse(this.entData.stateJson)] : [];
			}
			if (this.$refs.entData.validate()) {
				arr.push({
					name: "审核",
					state: this.state == 1 ? "1" : "0",
					stateNote: this.entData.stateNote,
					operator: this.user.citizenName,
					operateTime: this.$options.filters["date"](new Date(), "yyyy-MM-dd HH:mm:ss"),
				});
				let { id, areaCode, areaName, btime, etime, stateNote } = this.entData;
				let entity = { id, areaCode, areaName, btime, etime, stateNote, state: this.state, operator: this.user.username, stateJson: JSON.stringify(arr) };
				console.log(entity);
				Request.postJson("/udsx/dept-ureg/exam", entity).then((res) => {
					if (res.meta.success) {
						Message.toast(res.meta.message, { color: "success" });
						// this.tolist();
						this.$router.back(-1);
					} else {
						Message.toast("操作失败！", { color: "error" });
					}
				});
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.border {
	border: rgb(228, 228, 228) 1px solid;
}
.table_span {
	display: inline-block;
	min-width: 70px;
	text-align: justify;
	text-align-last: justify;
}
.title_icon {
	height: 3px;
	width: 20px;
	background: #2196f3;
	position: absolute;
	bottom: 0;
	left: 0;
	border-radius: 20px;
}
.examine_bg0 {
	background: url(../../assets/img/dsh.png) no-repeat;
	background-position: 100% -6%;
	background-size: 128px;
}
.examine_bg1 {
	background: url(../../assets/img/shtg.png) no-repeat;
	background-position: 100% -6%;
	background-size: 128px;
}
.examine_bg2 {
	background: url(../../assets/img/shbtg.png) no-repeat;
	background-position: 100% -6%;
	background-size: 128px;
}
.uamsShow ::v-deep .v-application--wrap {
	min-height: calc(100vh - 100px);
}
</style>
